// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I5pa","content":"styles_content__1ISOg","tableWrap":"styles_tableWrap__jMbXb"};